var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-footer "},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 yo-align-center"},[_vm._v("\n         BioMedia srl - via Libero Temolo 4 ­ torre U8 -­ 20126 Milano ­- P.IVA 10691860158\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79adc186","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-footer.vue
// module id = null
// module chunks = 